import { render, staticRenderFns } from "./ProgressSpinner.vue?vue&type=template&id=25920cc3&"
import script from "./ProgressSpinner.vue?vue&type=script&lang=js&"
export * from "./ProgressSpinner.vue?vue&type=script&lang=js&"
import style0 from "./ProgressSpinner.vue?vue&type=style&index=0&id=25920cc3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports